import Alert from '@storeblocks/alert';
import { type FC } from 'react';

import { useTexts } from '@/hooks/useTexts';

export const PostErrorAlert: FC = () => {
  const texts = useTexts();

  return (
    <Alert
      title={texts.orders.form.errors.postError.title}
      variant="error"
      data-test="post-error"
    >
      {texts.orders.form.errors.postError.message}{' '}
      <a href={`mailto:${texts.error.siosEmail}`}>{texts.error.siosEmail}</a>
    </Alert>
  );
};
